<div class="container">
  <!-- Header com Botão de Theme -->
  <div class="card mb-lg">
    <div class="title-primary">Olá, Ricardo!</div>
    <div class="title-primary-description">Bem-vindo de volta.</div>

    <button (click)="toggleTheme()" class="btn btn-primary mt-md">
      {{ isDarkMode ? '☀️ Light Mode' : '🌙 Dark Mode' }}
    </button>
  </div>

  <div class="card mb-lg">
    <div class="card card-white">
      <div class="title-secondary">Dra. Fernanda Mendes</div>
      <div class="title-secondary-description">Clínico Geral</div>
    </div>
    <button (click)="toggleTheme()" class="btn btn-primary mt-md btn-full-line">
      {{ isDarkMode ? '☀️ Light Mode' : '🌙 Dark Mode' }}
    </button>
  </div>

  <button class="btn btn-primary">Clique</button>


  <!-- ========== SEÇÃO: BOTÕES ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Botões (Legacy CSS)</h2>
    <div class="card mb-lg">
      <h3 class="card-title">Tamanhos</h3>
      <div>
        <button class="btn btn-primary btn-sm">Pequeno</button>
        <button class="btn btn-primary">Médio</button>
        <button class="btn btn-primary btn-lg">Grande</button>
      </div>
    </div>

    <div class="card">
      <h3 class="card-title">Variantes</h3>
      <div>
        <button class="btn btn-primary">Primary</button>
        <button class="btn btn-secondary">Secondary</button>
        <button class="btn btn-outline">Outline</button>
        <button class="btn btn-ghost">Ghost</button>
        <button class="btn btn-primary" disabled>Desabilitado</button>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: CARDS ========== -->
  <section class="mb-xl">
    <div class="title-section">Cards</div>
    <div class="mb-lg">
      <div class="card">
        <div class="card-header">
          <div class="card-title">Card Básico</div>
        </div>
        <div class="card-body">
          Este é um exemplo de card com header, body e footer. Os cards têm sombra e efeito hover.
        </div>
        <div class="card-footer">
          <button class="btn btn-primary btn-sm">Ação</button>
        </div>
      </div>

      <div class="card card-dark">
        <div class="card-header">
          <div class="card-title">Card Dark</div>
        </div>
        <div class="card-body">
          Card com variante dark, perfeito para destacar conteúdos importantes.
        </div>
        <div class="card-footer">
          <button class="btn btn-secondary btn-sm">Ver Mais</button>
        </div>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: INPUTS ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Inputs e Forms</h2>
    <div class="card">
      <h3 class="card-title">Formulário Exemplo</h3>
      <div><br /><br /><br />

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="firstName" data-cy="first-name-input" />
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="firstName" data-cy="first-name-input" [disabled]="true"
            value=" Meu teste de texto" />
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Descrição</mat-label>
          <textarea matInput rows="4" placeholder="Digite uma descrição..."></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Selecione uma opção</mat-label>
          <mat-select>
            <mat-option value="opcao1">Opção 1</mat-option>
            <mat-option value="opcao2">Opção 2</mat-option>
            <mat-option value="opcao3">Opção 3</mat-option>
          </mat-select>
        </mat-form-field>


        <div class="mb-md">
          <label class="text-sm font-semibold">Input Normal</label>
          <input type="text" class="input" placeholder="Digite algo...">
        </div>

        <div class="mb-md">
          <label class="text-sm font-semibold">Input Pequeno</label>
          <input type="text" class="input input-sm" placeholder="Input pequeno">
        </div>

        <div class="mb-md">
          <label class="text-sm font-semibold">Input Grande</label>
          <input type="text" class="input input-lg" placeholder="Input grande">
        </div>

        <div class="mb-md">
          <label class="text-sm font-semibold">Select</label>
          <select class="select">
            <option>Opção 1</option>
            <option>Opção 2</option>
            <option>Opção 3</option>
          </select>
        </div>

        <div class="mb-md">
          <label class="text-sm font-semibold">Textarea</label>
          <textarea class="textarea" placeholder="Digite uma mensagem..."></textarea>
        </div>

        <div class="mb-md">
          <label class="text-sm font-semibold">Input Desabilitado</label>
          <input type="text" class="input" placeholder="Desabilitado" disabled value="Não editável">
        </div>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: BADGES ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Badges e Status</h2>
    <div class="card mb-lg">
      <h3 class="card-title">Badges Padrão</h3>
      <div>
        <span class="badge badge-primary">Primary</span>
        <span class="badge badge-success">Success</span>
        <span class="badge badge-warning">Warning</span>
        <span class="badge badge-error">Error</span>
        <span class="badge badge-cancelled">Cancelled</span>
      </div>
    </div>

    <div class="card">
      <h3 class="card-title">Status de Faturas</h3>
      <div>
        <span class="badge invoice-status-pending">Pendente</span>
        <span class="badge invoice-status-paid">Pago</span>
        <span class="badge invoice-status-expired">Vencida</span>
        <span class="badge invoice-status-cancelled">Cancelada</span>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: ALERTS ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Alerts</h2>
    <div>
      <div class="alert alert-success mb-md">
        <span>✓</span>
        <div>
          <strong>Sucesso!</strong> Operação realizada com sucesso.
        </div>
      </div>

      <div class="alert alert-warning mb-md">
        <span>⚠</span>
        <div>
          <strong>Atenção!</strong> Esta ação requer confirmação.
        </div>
      </div>

      <div class="alert alert-error mb-md">
        <span>✕</span>
        <div>
          <strong>Erro!</strong> Ocorreu um problema ao processar sua solicitação.
        </div>
      </div>

      <div class="alert alert-info">
        <span>ℹ</span>
        <div>
          <strong>Informação:</strong> Novos recursos disponíveis.
        </div>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: LOADING SPINNERS ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Loading Spinners</h2>
    <div class="card">
      <div class="text-center mb-md">
        <div class="spinner spinner-sm"></div>
        <p class="text-sm">Pequeno</p>
      </div>
      <div class="text-center mb-md">
        <div class="spinner"></div>
        <p class="text-sm">Médio</p>
      </div>
      <div class="text-center">
        <div class="spinner spinner-lg"></div>
        <p class="text-sm">Grande</p>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: MENU GRID ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Menu Grid</h2>
    <div class="menu-grid">
      <a href="#" class="menu-item">
        <div class="menu-icon text-primary">
          📅
        </div>
        <span class="menu-label">Agenda</span>
      </a>
      <a href="#" class="menu-item">
        <div class="menu-icon text-success">
          📊
        </div>
        <span class="menu-label">Relatórios</span>
      </a>
      <a href="#" class="menu-item">
        <div class="menu-icon text-warning">
          💰
        </div>
        <span class="menu-label">Financeiro</span>
      </a>
      <a href="#" class="menu-item">
        <div class="menu-icon text-info">
          👥
        </div>
        <span class="menu-label">Pacientes</span>
      </a>
    </div>
  </section>

  <!-- ========== SEÇÃO: FILE CARDS ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">File Cards</h2>
    <div class="file-container">
      <div class="file-card">
        <div class="file-icon">
          <mat-icon>upload_file</mat-icon>
        </div>
        <div class="file-info">
          <h4 class="file-title">Hemograma Completo</h4>
          <p class="file-name">Dr. João Silva</p>
          <div class="file-meta">
            <p class="file-date">15/01/2026 às 14:30</p>
            <span class="file-status badge badge-success">Disponível</span>
          </div>
        </div>
        <div>
          <button mat-icon-button [matMenuTriggerFor]="fileMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #fileMenu="matMenu">
            <button mat-menu-item>
              <mat-icon>download</mat-icon>
              <span>Baixar</span>
            </button>

            <button mat-menu-item>
              <mat-icon>visibility_off</mat-icon><!-- 'visibility_off' : 'visibility'  -->
              <span>Bloquear Acesso</span><!-- Bloquear Acesso' : 'Permitir Acesso -->
            </button>

            <button mat-menu-item class=" delete-item">
              <mat-icon color="warn">delete</mat-icon>
              <span>Excluir</span>
            </button>

          </mat-menu>
        </div>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: SEARCH INPUT ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Search Input</h2>
    <div class="card">
      <input type="search" class="search-input" placeholder="🔍 Buscar exames, médicos, pacientes...">
    </div>
  </section>

  <!-- ========== SEÇÃO: MODAL EXEMPLO ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Modal (Exemplo Estático)</h2>
    <div class="card">
      <div class="modal">
        <div class="modal-header">
          <h3 class="modal-title">Título do Modal</h3>
        </div>
        <div class="modal-body">
          <p>Este é um exemplo de modal. Normalmente ele aparece sobre um backdrop com overlay.</p>
          <p class="mt-md">Você pode adicionar qualquer conteúdo aqui: formulários, informações, confirmações, etc.</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-ghost">Cancelar</button>
          <button class="btn btn-primary">Confirmar</button>
        </div>
      </div>
    </div>
  </section>

  <!-- ========== SEÇÃO: INPUT GROUP ========== -->
  <section class="mb-xl">
    <h2 class="text-primary">Input Group</h2>
    <div class="card">
      <div class="input-group">
        <input type="text" class="input" placeholder="Digite sua busca">
        <button class="btn btn-primary">Buscar</button>
      </div>
    </div>
  </section>

  <!-- Espaçamento para o bottom nav -->
  <div class="mb-xl"></div>
</div>

<!-- ========== BOTTOM NAVIGATION ========== -->
<nav class="bottom-nav">
  <a href="#" class="bottom-nav-item active">
    <div class="bottom-nav-icon">🏠</div>
    <span class="bottom-nav-label">Início</span>
  </a>
  <a href="#" class="bottom-nav-item">
    <div class="bottom-nav-icon">📅</div>
    <span class="bottom-nav-label">Agenda</span>
  </a>
  <a href="#" class="bottom-nav-item">
    <div class="bottom-nav-icon">📊</div>
    <span class="bottom-nav-label">Exames</span>
  </a>
  <a href="#" class="bottom-nav-item">
    <div class="bottom-nav-icon">👤</div>
    <span class="bottom-nav-label">Perfil</span>
  </a>
</nav>